import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';

export const isStandaloneGuard: CanActivateFn = async () => {
    const pwaIntegrationService = inject(PwaIntegrationService);
    return !!pwaIntegrationService?.isStandalone;
};
